import {useContext} from 'react';
import {generateHTML} from '@tiptap/react';
import Chip from 'patient-ping-remedy/packages/chip';
import {Message, MessageAttachment} from '@/api/dto/message';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {useAuthStore} from '@/store/auth_store';
import {useActiveRoster} from '@/store/roster_store';
import {extensions} from '@common/messages/MessageEditor';
import {Attachments} from '@common/messages/MessageEditor.styles';
import {Attachment, AvatarWrapper, Content, ContentWrapper, Wrapper} from '@common/messages/MessageItem.styles';
import AvatarDetails from '@common/AvatarDetails';
import FileHelpers from '@/helpers/file_helpers';

type Props = {
  message: Message;
  own: boolean;
  onAttachmentDelete(message: Message, attachment: MessageAttachment): void;
}

export default function MessageItem(props: Props) {
  const { carecoApi } = useContext(CarecoApiContext);
  const { currentUser } = useAuthStore();
  const currentRoster = useActiveRoster();

  const handleAttachmentDelete = (attachment: MessageAttachment) => {
    return currentUser?.id === props.message.user.id
      ? () => props.onAttachmentDelete(props.message, attachment)
      : null as any;
  };

  const handleAttachmentDownload = async (attachment: MessageAttachment, filename: string) => {
    const response = await carecoApi?.getMessageAttachment(attachment.id);
    if (response) {
      const arrayBuffer = FileHelpers.base64ToArrayBuffer(response);
      FileHelpers.handleFile(arrayBuffer, filename);
    }
  };

  return (
    <Wrapper own={props.own} data-message-id={props.message.id}>
      <AvatarWrapper>
        <AvatarDetails user={props.message.user} roster={currentRoster} />
      </AvatarWrapper>
      <ContentWrapper>
        <Content dangerouslySetInnerHTML={{ __html: generateHTML(props.message.content, extensions)} } />
        {props.message.attachments.length > 0 && (
          <Attachments>
            {props.message.attachments.map((attachment) => {
              const filename = attachment.s3Key.split('/').pop() ?? 'Unknown';
              return (
                <Chip key={attachment.id} onClick={handleAttachmentDelete(attachment)}>
                  <Attachment onClick={() => handleAttachmentDownload(attachment, filename)}>
                    {filename}
                  </Attachment>
                </Chip>
              );
            })}
          </Attachments>
        )}
      </ContentWrapper>
    </Wrapper>
  );
}
